import { auth } from "../../firebase/utils";
import { takeLatest, put, all, call } from "redux-saga/effects";
import { setPosts, 
  setPost, 
  fetchPostsStart, 
  updatePostSuccess, 
  fetchPostStart, 
  updatePostError, 
  adjustSavesError, 
  adjustSavesSuccess, 
  removePostMenuItemSuccess } from "./posts.actions";
import {
  handleAddPost,
  handleFetchPosts,
  handleFetchPost,
  handleDeletePost,
  handleUpdatePost,
  handleSearchPosts,
  handleIncreaseSaves,
  handleDecreaseSaves,
  handleUpdatePostMenu,
  handleRemovePostMenuItem,
} from "./posts.helpers";
import postsTypes from "./posts.types";

export function* addPost({ payload }) {
  try {
    const timestamp = new Date();
    yield handleAddPost({
      ...payload,
      userID: auth.currentUser.uid,
      userName: auth.currentUser.displayName,
      userEmail: auth.currentUser.email,
      createdDate: timestamp,
    });
    yield put(fetchPostsStart());
  } catch (err) {}
}

export function* onAddPostStart() {
  yield takeLatest(postsTypes.ADD_NEW_POST_START, addPost);
}

export function* fetchPosts({ payload }) {
  try {
    const posts = yield handleFetchPosts(payload);
    yield put(setPosts(posts));
  } catch (err) {
    // console.log(err);
  }
}

export function* onFetchPostsStart() {
  yield takeLatest(postsTypes.FETCH_POSTS_START, fetchPosts);
}

export function* fetchPost({ payload }) {
  try {
    const post = yield handleFetchPost(payload);
    yield put(setPost(post));
  } catch (err) {
    // console.log(err);
  }
}

export function* onFetchPostStart() {
  yield takeLatest(postsTypes.FETCH_POST_START, fetchPost);
}

export function* onDeletePostStart() {
  yield takeLatest(postsTypes.DELETE_POST_START, deletePost);
}

export function* deletePost({ payload }) {
  try {
    yield handleDeletePost(payload);
    yield put(fetchPostsStart());
  } catch (err) {
    // console.log(err);
  }
}

export function* searchPosts({ payload }) {
  try {
    const posts = yield handleSearchPosts(payload);
    yield put(setPosts(posts));
  } catch (err) {
    // Handle or log the error
  }
}

export function* onSearchPostsStart() {
  yield takeLatest(postsTypes.SEARCH_POSTS_START, searchPosts);
}

export function* updatePost({ payload }) {
  try {
    const { postID, updatedData } = payload;
    yield call(handleUpdatePost, postID, updatedData);
    yield put(updatePostSuccess());
    yield put(fetchPostStart(postID));
  } catch (error) {
    yield put(updatePostError(error));
  }
}

export function* onUpdatePostStart() {
  yield takeLatest(postsTypes.UPDATE_POST_START, updatePost);
}

export function* increaseSaves({ payload }) {
  try {
    yield call(handleIncreaseSaves, payload);
    yield put(adjustSavesSuccess());
  } catch (error) {
    yield put(adjustSavesError(error));
  }
}

export function* decreaseSaves({ payload }) {
  try {
    yield call(handleDecreaseSaves, payload);
    yield put(adjustSavesSuccess());
  } catch (error) {
    yield put(adjustSavesError(error));
  }
}

export function* onIncreaseSavesStart() {
  yield takeLatest(postsTypes.INCREASE_SAVES_START, increaseSaves);
}

export function* onDecreaseSavesStart() {
  yield takeLatest(postsTypes.DECREASE_SAVES_START, decreaseSaves);
}

//UPDATE OR REMOVE POST MENU
export function* updatePostMenu({ payload }) {
  try {
    const { documentID, ...updatedMenu } = payload;
    yield handleUpdatePostMenu(documentID, updatedMenu);
    yield put(fetchPostsStart());
  } catch (err) {
    // console.log(err);
  }
}
export function* onUpdatePostMenuStart() {
  yield takeLatest(postsTypes.UPDATE_POST_MENU_START, updatePostMenu);
}

export function* removePostMenuItem({ payload }) {
  try {
    const { documentID, mealType, postID } = payload;
    yield call(handleRemovePostMenuItem, documentID, mealType, postID);
    const updatedMenu = yield call(handleFetchPost, documentID);
    const isEmptyMenu = ["breakfast", "lunch", "dinner", "snack", "baby", "pet"]
      .every((meal) => !updatedMenu[meal] || updatedMenu[meal].length === 0);

    if (isEmptyMenu) {
      yield call(handleDeletePost, documentID);
    yield put(fetchPostsStart());

    } else {
      yield put(removePostMenuItemSuccess(updatedMenu));
    yield put(fetchPostsStart());

    }
  } catch (err) {
    console.log(err);
  }
}
export function* onRemovePostMenuItemStart() {
  yield takeLatest(postsTypes.REMOVE_POST_MENU_ITEM_START, removePostMenuItem);
}


export default function* postsSagas() {
  yield all([
    call(onAddPostStart),
    call(onFetchPostsStart),
    call(onFetchPostStart),
    call(onDeletePostStart),
    call(onSearchPostsStart),
    call(onUpdatePostStart),
    call(onIncreaseSavesStart),
    call(onDecreaseSavesStart),
    call(onUpdatePostMenuStart),
    call(onRemovePostMenuItemStart),
  ]);
}
